import React from 'react';
import { Tooltip } from '@mui/material';
import EditCloneDeleteMenu from "../../Menus/EditCloneDeleteMenu";



export const SubscriberGridColumns = ({ hideActions, onEdit, onClone, onDelete }) => [
    {
        field: "more",
        headerName: '',
        width: 20,
        sortable: false,
        filterable: false,
        hide: hideActions,
        renderCell: (params) => (
            <Tooltip title={`Click to see actions for record ${params.row.id}`}>
                <EditCloneDeleteMenu
                    onEdit={() => onEdit(params.row)}
                    onClone={() => onClone(params.row)}
                    onDelete={() => onDelete(params.row)}
                />
            </Tooltip>
        )
    },
    {    field: 'id',
        headerName: 'ID',
        description: 'This column has a value getter and is not sortable.',
        sortable: true,
        width: 60,
    },
    {
        field: 'externalId',
        headerName: 'External ID',
        description: 'This column has a value getter and is not sortable.',
        sortable: true,
        // editable: true,
        width: 100,
    },
    {
        field: 'service',
        headerName: 'Service',
        description: 'This column has a value getter and is not sortable.',
        sortable: true,
        width: 150,
    },
    {
        field: 'source',
        headerName: 'Source',
        description: 'This column has a value getter and is not sortable.',
        sortable: true,
        width: 150,
    },
    {
        field: 'subCount',
        headerName: 'Count',
        description: 'This column has a value getter and is not sortable.',
        sortable: true,
        width: 150,
    },
    {
        field: 'countDate',
        headerName: 'Date',
        description: 'This column has a value getter and is not sortable.',
        sortable: true,
        width: 150,
    },
    {
        field: 'status',
        headerName: 'Status',
        sortable: true,
        width: 150,
    },

];
